import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { headersAuth } from '../../../../../../Services/AuthService';
import { servicios_grupogack_catalogo, tipos_ausentismos } from '../../../../../../Constants/Constants';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

import tipoausentismojson from '../../../../../Datos/tipoAusentismo.json';

const TiposAusentismos = ({ id, permisos }) => {
    const [ tiposAusentismo, setTiposAusentismo ] = useState( null );
    useEffect(() => {
        axiosTiposAusentismo();
    }, []);

    const axiosTiposAusentismo = () => {/*
        axios.get( `${servicios_grupogack_catalogo}/tipoausentismo/`, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:*/
                        setTiposAusentismo( tipoausentismojson );
                        /*break;
                    case 404:
                        setTiposAusentismo([]);
                        break;
                    default:
                        break;
                }
            })
            .catch( error => { console.log( error ) })*/
    }

    return (
        <div id={ id }>
            { tiposAusentismo ?
                <DataTableService id={id} title={ tipos_ausentismos } permisos={permisos}
                    columns={[
                        { field: "ausentismoCve", title: "Clave" },
                        { field: "ausentismoNom", title: "Nombre" },
                    ]}
                    data={ tiposAusentismo } /> : <SpinnerOval />
            }
        </div>
    );
}
 
export default TiposAusentismos;